/* Fast Tuning Car — Mobile navigation bridge
 * Opens the existing native "Nos Catégories" drawer from the FTC main menu.
 * Keeps Arena's native category drawer/lazy loading intact.
 */
(function () {
  'use strict';

  function openCategories() {
    var header = document.getElementById('header-mobile-container');
    if (!header) return;

    var mainDrawer = document.getElementById('mobile-drawer-main');
    var closeMain = mainDrawer && mainDrawer.querySelector('.js-btn-close');

    if (closeMain) {
      closeMain.click();
    } else if (mainDrawer) {
      mainDrawer.classList.remove('is-open');
    }

    window.setTimeout(function () {
      var openCategoriesButton = header.querySelector('.js-sub-drawer-open-button');
      if (openCategoriesButton) {
        openCategoriesButton.click();
      }
    }, 140);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ftc-open-categories');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openCategories();
  });
})();
